"use client"

import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from "./ui/carousel"
import { Testimonial } from "@/types/types"
import TestimonialCard from "./TestimonialCard"

type TestimonialsCarouselProps = {
    testimonials: Testimonial[]
}

export const TestimonialsCarousel = ({ testimonials }: TestimonialsCarouselProps) => {
    return (
        <Carousel
            opts={{
                align: "start",
                loop: testimonials.length > 3,
            }}
            className="w-full"
        >
            <CarouselContent className="-ml-2 md:-ml-4">
                {testimonials.map((testimonial) => (
                    <CarouselItem key={testimonial.id} className="pl-2 md:pl-4 md:basis-1/2 lg:basis-1/3">
                        <TestimonialCard testimonial={testimonial} />
                    </CarouselItem>
                ))}
            </CarouselContent>
            {testimonials.length > 1 && (
                <div className="flex justify-center gap-4 mt-8">
                    <CarouselPrevious className="relative top-0 left-0 translate-x-0 translate-y-0" />
                    <CarouselNext className="relative top-0 right-0 translate-x-0 translate-y-0" />
                </div>
            )}
        </Carousel>
    )
}

